export const experimentConfigs = new Map();
export const activeVariants = new Map();
export const variantsDefinedExperiments = new Set();
export const playedExperiments = new Set();
export const resetPlayedExperiments = () => {
    activeVariants.clear();
    playedExperiments.clear();
};
export const resetExperiments = () => {
    activeVariants.clear();
    experimentConfigs.clear();
    variantsDefinedExperiments.clear();
    playedExperiments.clear();
};
